import type { AgendaRegistration } from '@/shared/navigation';

import { WWW_WEB_FILTERS } from './permissions';
import { webFilterListAgenda } from './web-filters/list/webFilterListAgenda';
import { WebFilterListPage } from './web-filters/list/WebFilterListPage';
import { webFilterFormAgenda } from './web-filters/createDetail/webFilterFormAgenda';
import { WebFilterFormPage } from './web-filters/createDetail/WebFilterFormPage';

export const wwwWebFiltersAgendas: AgendaRegistration[] = [
  { agenda: webFilterListAgenda, component: WebFilterListPage, permission: WWW_WEB_FILTERS },
  { agenda: webFilterFormAgenda, component: WebFilterFormPage, permission: WWW_WEB_FILTERS },
];
